import * as types from '../../action-types';
import {getMyISOStageHistory as initialState } from "../../initialState";

const getMyISOStageHistory = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_MY_ISO_STAGE_HISTORY_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_MY_ISO_STAGE_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_MY_ISO_STAGE_HISTORY_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_MY_ISO_STAGE_HISTORY_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getMyISOStageHistory;

